<ng-content></ng-content>
<span (click)="toggle('asc')" *ngIf="direction === 'desc'" class="sortButton" [class.active]="isActive()">
    <i class="fa fa-arrow-down"></i>
</span>
<span (click)="toggle('desc')" *ngIf="!direction || direction === 'asc'" class="sortButton" [class.active]="isActive()">
    <i class="fa fa-arrow-up"></i>
</span>
